export default __webpack_public_path__ + "static/backgroundOurValue-b4412ff757c233549d12ccd5761c60bc.svg";